/**
 * Cart drawer "PRE-ORDER" label — marks pre-order lines inside UpCart's cart drawer.
 * Markup + the server-side map: snippets/cart-preorder-label.liquid (rendered from layout/theme.liquid).
 *
 * PRE-ORDER RULE = the product card badge's (snippets/p-c.liquid): a product tag containing "pre-order" or
 * "preorder", any case. Keep the two (and the snippet's Liquid copy) in sync.
 *
 * WHICH PRODUCTS ARE PRE-ORDER
 *   1. Lines already in the cart at page load — printed by the snippet (script[data-ss-cart-preorder]), no fetch.
 *   2. Anything added later — /products/<handle>.js (has `tags`), once per product per page view.
 *      ⚠️ `shopify theme dev` 401s that URL → on dev, a line added after load gets its label only after a reload.
 *
 * WHICH ROW IS WHICH: the drawer here is UpCart's V2 cart-items module — rows (li.upcart-public-cart-item) carry
 * NO line key or id. The title link does: /products/<handle>?variant=<id>. Free-gift rows have no link → skipped.
 * (UpCart's V1 doc recipe, [id="<key>"].upcart-product-item, doesn't apply here.) Verified live 2026-11-03.
 *
 * UpCart (React) redraws rows on cart changes and may drop our span → a MutationObserver on the drawer
 * re-applies (idempotent, batched per frame). Display only — never touches the cart. Fail-closed: any problem
 * = no label.
 */
(function () {
  'use strict';

  var LABEL_CLASS = 'ss-cart-preorder';
  var ROW = '.upcart-public-cart-item';
  var LINK = '.upcart-public-component-product-tile__title-link';
  var SLOT = '.upcart-public-component-product-tile__properties'; // empty per-line slot, under the size
  var HANDLE_RE = /\/products\/([^/?#]+)/;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var known = {}; // handle -> true / false
  var pending = {}; // handle -> true while its fetch is in flight
  var scheduled = false;

  // 1. Lines in the cart at page load.
  var seed = document.querySelector('script[data-ss-cart-preorder]');
  if (seed) {
    try {
      known = JSON.parse(seed.textContent) || {};
    } catch (err) {
      known = {};
    }
  }

  function isPreorder(tags) {
    var t = (tags || []).join(',').toLowerCase();
    return t.indexOf('pre-order') !== -1 || t.indexOf('preorder') !== -1;
  }

  // 2. Lines added after load.
  function lookup(handle) {
    if (pending[handle]) return;
    pending[handle] = true;
    fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (product) {
        known[handle] = !!(product && isPreorder(product.tags));
      })
      .catch(function () {
        known[handle] = false;
      })
      .then(function () {
        delete pending[handle];
        schedule();
      });
  }

  function handleOf(row) {
    var link = row.querySelector(LINK);
    var m = link && HANDLE_RE.exec(link.getAttribute('href') || '');
    if (!m) return null;
    try {
      return decodeURIComponent(m[1]);
    } catch (err) {
      return m[1];
    }
  }

  function apply() {
    scheduled = false;
    var rows = document.querySelectorAll(ROW);
    for (var i = 0; i < rows.length; i++) {
      var slot = rows[i].querySelector(SLOT);
      if (!slot) continue;
      var handle = handleOf(rows[i]);
      var label = slot.querySelector('.' + LABEL_CLASS);

      // A row React reused for another line keeps our old span — drop it.
      if (label && label.getAttribute('data-handle') !== handle) {
        label.remove();
        label = null;
      }
      if (!handle) continue;
      if (!Object.prototype.hasOwnProperty.call(known, handle)) {
        lookup(handle);
        continue;
      }

      if (known[handle] && !label) {
        label = document.createElement('span');
        label.className = LABEL_CLASS + ' label-sm';
        label.setAttribute('data-handle', handle);
        label.textContent = 'PRE-ORDER';
        slot.appendChild(label);
      } else if (!known[handle] && label) {
        label.remove();
      }
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(apply);
  }

  // Watch the drawer's parent (UpCart's app-embed block — stable), so a remount of #upCart is still seen.
  function watch(drawer) {
    new MutationObserver(schedule).observe(drawer.parentNode || drawer, { childList: true, subtree: true });
    schedule();
  }

  var drawer = document.getElementById('upCart');
  if (drawer) {
    watch(drawer);
  } else {
    // UpCart not mounted yet — wait for it once, then watch only the drawer.
    var finder = new MutationObserver(function () {
      var found = document.getElementById('upCart');
      if (!found) return;
      finder.disconnect();
      watch(found);
    });
    finder.observe(document.body, { childList: true, subtree: true });
  }
})();
